module.exports = __webpack_public_path__ + "static/img/1.efe2022.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/1.png
// module id = D15V
// module chunks = 0